export default __webpack_public_path__ + "static/media/found-location.9a2c0e78.svg";